import { a } from '../global-constants';

const initialState = {};

const account = (state = initialState, { type, payload }) => {
	switch (type) {
		case a.SET_ACCOUNT: {
			return {
				...state,
				...payload
			};
		}
		default:
			return state;
	}
};

export default account;
